// extracted by mini-css-extract-plugin
module.exports = {"body":"_e43af97d","itemTitle":"_f6398598","portfolioName":"_a4175110","designerConnectionWrapper":"_b62174d"};